"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
const commander = __importStar(require("commander"));
const path = __importStar(require("path"));
const TInputCLIOptions_1 = require("../types/options/TInputCLIOptions");
const Initializable_1 = require("../decorators/Initializable");
const Default_1 = require("../options/presets/Default");
const ArraySanitizer_1 = require("./sanitizers/ArraySanitizer");
const BooleanSanitizer_1 = require("./sanitizers/BooleanSanitizer");
const IdentifierNamesGeneratorSanitizer_1 = require("./sanitizers/IdentifierNamesGeneratorSanitizer");
const ObfuscatingTargetSanitizer_1 = require("./sanitizers/ObfuscatingTargetSanitizer");
const SourceMapModeSanitizer_1 = require("./sanitizers/SourceMapModeSanitizer");
const StringArrayEncodingSanitizer_1 = require("./sanitizers/StringArrayEncodingSanitizer");
const CLIUtils_1 = require("./utils/CLIUtils");
const JavaScriptObfuscatorFacade_1 = require("../JavaScriptObfuscatorFacade");
const ObfuscatedCodeWriter_1 = require("./utils/ObfuscatedCodeWriter");
const SourceCodeReader_1 = require("./utils/SourceCodeReader");
class JavaScriptObfuscatorCLI {
    constructor(argv) {
        this.rawArguments = argv;
        this.arguments = argv.slice(2);
    }
    static buildOptions(inputOptions, inputCodePath) {
        const inputCLIOptions = JavaScriptObfuscatorCLI.filterOptions(inputOptions);
        const configFilePath = inputOptions.config;
        const configFileLocation = configFilePath ? path.resolve(configFilePath, '.') : '';
        const configFileOptions = configFileLocation ? CLIUtils_1.CLIUtils.getUserConfig(configFileLocation) : {};
        const inputFileName = path.basename(inputCodePath);
        const inputFilePath = inputCodePath;
        return Object.assign(Object.assign(Object.assign(Object.assign({}, Default_1.DEFAULT_PRESET), configFileOptions), inputCLIOptions), { inputFileName,
            inputFilePath });
    }
    static filterOptions(options) {
        const filteredOptions = {};
        Object
            .keys(options)
            .forEach((option) => {
            if (options[option] === undefined) {
                return;
            }
            filteredOptions[option] = options[option];
        });
        return filteredOptions;
    }
    initialize() {
        this.inputPath = path.normalize(this.arguments[0] || '');
        this.commands = (new commander.Command());
        this.configureCommands();
        this.configureHelp();
        this.inputCLIOptions = this.commands.opts();
        this.sourceCodeReader = new SourceCodeReader_1.SourceCodeReader(this.inputPath, this.inputCLIOptions);
        this.obfuscatedCodeWriter = new ObfuscatedCodeWriter_1.ObfuscatedCodeWriter(this.inputPath, this.inputCLIOptions);
    }
    run() {
        const canShowHelp = !this.arguments.length || this.arguments.includes('--help');
        if (canShowHelp) {
            this.commands.outputHelp();
            return;
        }
        const sourceCodeData = this.sourceCodeReader.readSourceCode();
        this.processSourceCodeData(sourceCodeData);
    }
    configureCommands() {
        var _a;
        this.commands
            .usage('<inputPath> [options]')
            .version((_a = process.env.VERSION) !== null && _a !== void 0 ? _a : 'unknown', '-v, --version')
            .option('-o, --output <path>', 'Output path for obfuscated code')
            .option('--compact <boolean>', 'Disable one line output code compacting', BooleanSanitizer_1.BooleanSanitizer)
            .option('--config <boolean>', 'Name of js / json config file')
            .option('--control-flow-flattening <boolean>', 'Enables control flow flattening', BooleanSanitizer_1.BooleanSanitizer)
            .option('--control-flow-flattening-threshold <number>', 'The probability that the control flow flattening transformation will be applied to the node', parseFloat)
            .option('--dead-code-injection <boolean>', 'Enables dead code injection', BooleanSanitizer_1.BooleanSanitizer)
            .option('--dead-code-injection-threshold <number>', 'The probability that the dead code injection transformation will be applied to the node', parseFloat)
            .option('--debug-protection <boolean>', 'Disable browser Debug panel (can cause DevTools enabled browser freeze)', BooleanSanitizer_1.BooleanSanitizer)
            .option('--debug-protection-interval <boolean>', 'Disable browser Debug panel even after page was loaded (can cause DevTools enabled browser freeze)', BooleanSanitizer_1.BooleanSanitizer)
            .option('--disable-console-output <boolean>', 'Allow console.log, console.info, console.error and console.warn messages output into browser console', BooleanSanitizer_1.BooleanSanitizer)
            .option('--domain-lock <list> (comma separated, without whitespaces)', 'Blocks the execution of the code in domains that do not match the passed RegExp patterns (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--exclude <list> (comma separated, without whitespaces)', 'A filename or glob which indicates files to exclude from obfuscation', ArraySanitizer_1.ArraySanitizer)
            .option('--identifier-names-generator <string>', 'Sets identifier names generator. ' +
            'Values: hexadecimal, mangled, dictionary. ' +
            'Default: hexadecimal', IdentifierNamesGeneratorSanitizer_1.IdentifierNamesGeneratorSanitizer)
            .option('--identifiers-prefix <string>', 'Sets prefix for all global identifiers.')
            .option('--identifiers-dictionary <list> (comma separated, without whitespaces)', 'Identifiers dictionary (comma separated) for `--identifier-names-generator dictionary` option', ArraySanitizer_1.ArraySanitizer)
            .option('--log <boolean>', 'Enables logging of the information to the console', BooleanSanitizer_1.BooleanSanitizer)
            .option('--reserved-names <list> (comma separated, without whitespaces)', 'Disables obfuscation and generation of identifiers, which being matched by passed RegExp patterns (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--reserved-strings <list> (comma separated, without whitespaces)', 'Disables transformation of string literals, which being matched by passed RegExp patterns (comma separated)', ArraySanitizer_1.ArraySanitizer)
            .option('--rename-globals <boolean>', 'Allows to enable obfuscation of global variable and function names with declaration.', BooleanSanitizer_1.BooleanSanitizer)
            .option('--rotate-string-array <boolean>', 'Enable rotation of string array values during obfuscation', BooleanSanitizer_1.BooleanSanitizer)
            .option('--seed <string|number>', 'Sets seed for random generator. This is useful for creating repeatable results.', parseFloat)
            .option('--self-defending <boolean>', 'Disables self-defending for obfuscated code', BooleanSanitizer_1.BooleanSanitizer)
            .option('--shuffle-string-array <boolean>', 'Randomly shuffles string array items', BooleanSanitizer_1.BooleanSanitizer)
            .option('--source-map <boolean>', 'Enables source map generation', BooleanSanitizer_1.BooleanSanitizer)
            .option('--source-map-base-url <string>', 'Sets base url to the source map import url when `--source-map-mode=separate`')
            .option('--source-map-file-name <string>', 'Sets file name for output source map when `--source-map-mode=separate`')
            .option('--source-map-mode <string>', 'Specify source map output mode. ' +
            'Values: inline, separate. ' +
            'Default: separate', SourceMapModeSanitizer_1.SourceMapModeSanitizer)
            .option('--split-strings <boolean>', 'Splits literal strings into chunks with length of `splitStringsChunkLength` option value', BooleanSanitizer_1.BooleanSanitizer)
            .option('--split-strings-chunk-length <number>', 'Sets chunk length of `splitStrings` option', parseFloat)
            .option('--string-array <boolean>', 'Disables gathering of all literal strings into an array and replacing every literal string with an array call', BooleanSanitizer_1.BooleanSanitizer)
            .option('--string-array-encoding <string|boolean>', 'Encodes all strings in strings array using base64 or rc4 (this option can slow down your code speed. ' +
            'Values: true, false, base64, rc4. ' +
            'Default: false', StringArrayEncodingSanitizer_1.StringArrayEncodingSanitizer)
            .option('--string-array-threshold <number>', 'The probability that the literal string will be inserted into stringArray (Default: 0.8, Min: 0, Max: 1)', parseFloat)
            .option('--target <string>', 'Allows to set target environment for obfuscated code. ' +
            'Values: browser, browser-no-eval, node. ' +
            'Default: browser', ObfuscatingTargetSanitizer_1.ObfuscationTargetSanitizer)
            .option('--transform-object-keys <boolean>', 'Enables transformation of object keys', BooleanSanitizer_1.BooleanSanitizer)
            .option('--unicode-escape-sequence <boolean>', 'Allows to enable/disable string conversion to unicode escape sequence', BooleanSanitizer_1.BooleanSanitizer)
            .parse(this.rawArguments);
    }
    configureHelp() {
        this.commands.on('--help', () => {
            console.log('  Examples:\n');
            console.log('    %> javascript-obfuscator input_file_name.js --compact true --self-defending false');
            console.log('    %> javascript-obfuscator input_file_name.js --output output_file_name.js --compact true --self-defending false');
            console.log('    %> javascript-obfuscator input_directory_name --compact true --self-defending false');
            console.log('');
        });
    }
    processSourceCodeData(sourceCodeData) {
        sourceCodeData.forEach(({ filePath, content }, index) => {
            const outputCodePath = this.obfuscatedCodeWriter.getOutputCodePath(filePath);
            this.processSourceCode(content, filePath, outputCodePath, index);
        });
    }
    processSourceCode(sourceCode, inputCodePath, outputCodePath, sourceCodeIndex) {
        var _a;
        let options = JavaScriptObfuscatorCLI.buildOptions(this.inputCLIOptions, inputCodePath);
        if (sourceCodeIndex !== null) {
            const baseIdentifiersPrefix = (_a = this.inputCLIOptions.identifiersPrefix) !== null && _a !== void 0 ? _a : JavaScriptObfuscatorCLI.baseIdentifiersPrefix;
            const identifiersPrefix = `${baseIdentifiersPrefix}${sourceCodeIndex}`;
            options = Object.assign(Object.assign({}, options), { identifiersPrefix });
        }
        if (options.sourceMap) {
            this.processSourceCodeWithSourceMap(sourceCode, outputCodePath, options);
        }
        else {
            this.processSourceCodeWithoutSourceMap(sourceCode, outputCodePath, options);
        }
    }
    processSourceCodeWithoutSourceMap(sourceCode, outputCodePath, options) {
        const obfuscatedCode = JavaScriptObfuscatorFacade_1.JavaScriptObfuscator.obfuscate(sourceCode, options).getObfuscatedCode();
        this.obfuscatedCodeWriter.writeFile(outputCodePath, obfuscatedCode);
    }
    processSourceCodeWithSourceMap(sourceCode, outputCodePath, options) {
        var _a;
        const outputSourceMapPath = this.obfuscatedCodeWriter.getOutputSourceMapPath(outputCodePath, (_a = options.sourceMapFileName) !== null && _a !== void 0 ? _a : '');
        options = Object.assign(Object.assign({}, options), { sourceMapFileName: path.basename(outputSourceMapPath) });
        const obfuscatedCode = JavaScriptObfuscatorFacade_1.JavaScriptObfuscator.obfuscate(sourceCode, options);
        this.obfuscatedCodeWriter.writeFile(outputCodePath, obfuscatedCode.getObfuscatedCode());
        if (options.sourceMapMode === 'separate' && obfuscatedCode.getSourceMap()) {
            this.obfuscatedCodeWriter.writeFile(outputSourceMapPath, obfuscatedCode.getSourceMap());
        }
    }
}
JavaScriptObfuscatorCLI.encoding = 'utf8';
JavaScriptObfuscatorCLI.obfuscatedFilePrefix = '-obfuscated';
JavaScriptObfuscatorCLI.baseIdentifiersPrefix = 'a';
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", typeof (_a = typeof commander !== "undefined" && commander.CommanderStatic) === "function" ? _a : Object)
], JavaScriptObfuscatorCLI.prototype, "commands", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", typeof (_b = typeof TInputCLIOptions_1.TInputCLIOptions !== "undefined" && TInputCLIOptions_1.TInputCLIOptions) === "function" ? _b : Object)
], JavaScriptObfuscatorCLI.prototype, "inputCLIOptions", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", String)
], JavaScriptObfuscatorCLI.prototype, "inputPath", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", typeof (_c = typeof SourceCodeReader_1.SourceCodeReader !== "undefined" && SourceCodeReader_1.SourceCodeReader) === "function" ? _c : Object)
], JavaScriptObfuscatorCLI.prototype, "sourceCodeReader", void 0);
__decorate([
    Initializable_1.initializable(),
    __metadata("design:type", typeof (_d = typeof ObfuscatedCodeWriter_1.ObfuscatedCodeWriter !== "undefined" && ObfuscatedCodeWriter_1.ObfuscatedCodeWriter) === "function" ? _d : Object)
], JavaScriptObfuscatorCLI.prototype, "obfuscatedCodeWriter", void 0);
exports.JavaScriptObfuscatorCLI = JavaScriptObfuscatorCLI;
